import ERROR_CODES from "../common/ErrorCodes";

export const IMAGE_MAX_SIZE = 4000000; // 4MB
export const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png"];

export const validateFile = (file) => {
  if (file.size > IMAGE_MAX_SIZE) {
    throw new Error(ERROR_CODES.IMAGE_TOO_LARGE);
  }

  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    throw new Error(ERROR_CODES.IMAGE_INVALID_TYPE);
  }

  return true;
};
